<script>
import { useEnrollmentStore } from "@/stores/access/enrollment-store.js";
import { useAuthStore } from "@/stores/auth-store";
import { useSharedStore } from "@/stores/shared-store";
import { computed } from "vue";
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import CourseCard from "@/components/CustomComponent/shared/CourseCard.vue";
import { useExamFetchStore } from "@/stores/exam/exam-fetch-store";

export default {
  components: {
    BaseLoading,
    CourseCard,
  },

  setup() {
    const enrollmentStore = useEnrollmentStore();
    const authStore = useAuthStore();
    const sharedStore = useSharedStore();
    const examFetchStore = useExamFetchStore();

    const validEnrollments = computed(() =>
      enrollmentStore.enrollmentStudent.filter(
        (enrollment) => enrollment?.courseID
      )
    );
    const ongoingEnrollmentCount = computed(
      () =>
        validEnrollments.value.filter(
          (enrollment) => enrollment.status === "Ongoing"
        ).length
    );
    const completedEnrollmentCount = computed(
      () =>
        validEnrollments.value.filter(
          (enrollment) => enrollment.status === "Completed"
        ).length
    );
    return {
      enrollmentStore,
      authStore,
      sharedStore,
      validEnrollments,
      ongoingEnrollmentCount,
      completedEnrollmentCount,
      examFetchStore,
    };
  },
  
  mounted() {
    this.enrollmentStore.fetchEnrollmentStudentList(this.authStore.currentUser.id);
    this.authStore.authUser();
    this.examFetchStore.fetchExamSubmissionsListBySelf();
  },
  computed:{
    examList(){
      return this.examFetchStore.myExamSubmission.slice(-10);
    }
  },

  methods: {
    progressColor(status) {
      if (status === "Passed") return "success";
      if (status === "Failed") return "danger";
      return "warning";
    },
  },
};
</script>

<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">Dashboard</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Dashboard
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <!-- profile box -->
      <student-header></student-header>
      <!-- profile box -->
      <div class="row">
        <!-- sidebar -->
        <student-sidebar></student-sidebar>
        <!-- sidebar -->

        <div class="col-lg-9">
          <div class="row">
            <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-primary-transparent me-2 me-xxl-3 flex-shrink-0"
                      ><img src="@/assets/img/icon/graduation.svg" alt=""
                    /></span>
                    <div>
                      <span class="d-block">Enrolled Courses</span>
                      <h4 class="fs-24 mt-1">
                        {{ validEnrollments.length }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-secondary-transparent me-2 me-xxl-3 flex-shrink-0"
                      ><img src="@/assets/img/icon/book.svg" alt=""
                    /></span>
                    <div>
                      <span class="d-block">In Progress Courses</span>
                      <h4 class="fs-24 mt-1">{{ ongoingEnrollmentCount }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span
                      class="icon-box bg-success-transparent me-2 me-xxl-3 flex-shrink-0"
                      ><img src="@/assets/img/icon/bookmark.svg" alt=""
                    /></span>
                    <div>
                      <span class="d-block">Completed Courses</span>
                      <h4 class="fs-24 mt-1">{{ completedEnrollmentCount }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h5 class="mb-3 fs-18">Recently Enrolled Courses</h5>
          <div class="row">
            <div
              class="text-center p-5 bg-light border rounded mx-3 mb-3"
              v-if="validEnrollments.length == 0"
            >
              <h5 class="mb-2">Belum ada course yang diikuti</h5>
              <p class="mb-3">
                Silakan jelajahi dan daftar course dari halaman katalog.
              </p>
              <router-link to="/course/course-grid" class="btn btn-primary">
                Cari Course
              </router-link>
            </div>
            <div
              class="col-xl-4 col-md-6"
              v-for="(item, index) in validEnrollments.slice(0, 3)"
              :key="item.courseID.course_id || index"
            >
              <CourseCard :course="item.courseID" :status="item.status" />
            </div>
          </div>
          <div>
            <div class="row">
              <div class="col-xl-12">
                <div class="card mb-0 mt-3">
                  <h5 class="p-3 fs-18 border-bottom">Latest Exam</h5>
                  <div class="card-body">
                    <div
                      class="text-center p-4 bg-light border rounded"
                      v-if="examList.length === 0"
                    >
                      <h5 class="mb-2">Belum ada hasil exam</h5>
                      <p class="mb-0 text-muted">
                        Hasil exam yang sudah dikerjakan akan muncul di sini.
                      </p>
                    </div>
                    <template v-else>
                      <div
                        class="exam-item d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between row-gap-2 mb-3"
                        v-for="(item, index) in examList"
                        :key="index"
                      >
                        <div>
                          <h6 class="mb-1">{{ item.course_title }}</h6>
                          <div class="d-flex align-items-center">
                            <p>Attempt: {{ item.attempt }}</p>
                          </div>
                        </div>
                        <div
                          class="circle-progress flex-shrink-0"
                          :data-value="item.totalScore"
                          :class="progressColor(item.status)"
                          :style="{ '--value': item.totalScore }"
                        >
                          <div class="progress-value">{{ item.totalScore ? item.totalScore : 0 }}</div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <footer-two></footer-two> -->
  <BaseLoading v-show="sharedStore.loading"></BaseLoading>
</template>
<style scoped>
.exam-item {
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb; /* abu halus */
}
.exam-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
/* Override .course-item h5 line-clamp so flex + text-truncate can shrink cleanly */
.course-item-two .course-content h5.text-truncate {
  display: block;
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
</style>
